import { forwardRef, HTMLProps } from 'react'

type InputProps = HTMLProps<HTMLInputElement>

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, id, readOnly, type = 'text', ...rest }, ref) => (
    <div className='text-right mb-2'>
      <input
        id={id}
        className="bg-transparent text-xs text-gray-700 text-right outline-none"
        type={type}
        ref={ref}
        {...rest}
        readOnly={readOnly}
      />
    </div>
  )
)

export default Input
